import {WorkspaceTabKindType} from '@toolify/client/src/modules/workspaceTabs/enum/WorkspaceTabKindType'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'

export function getResourceWorkspaceTabKey(resourceType: ResourceType, resourceId: string): string {
  return `${WorkspaceTabKindType.Resource}:${resourceType}:${resourceId}`
}
